import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as Inventory from 'src/replicant/inventory';
import * as Pet from 'src/replicant/pet';
import { PartialRecord } from '@play-co/timestep-core';
import { State } from 'src/replicant/State';

type Compensation = {
  toy: number;
  food: number;
  bPoints: number;
  gems: number;
  energy: number;
  stars: number;
};

type InventoryState = {
  compensation: Compensation;
  /** When true, Header freezes its display and ignores state changes */
  displayFrozen: boolean;

  effectiveMultiplier: Record<'stomach' | 'love', number>;
};

const initialState: InventoryState = {
  compensation: {
    toy: 0,
    food: 0,
    bPoints: 0,
    gems: 0,
    energy: 0,
    stars: 0,
  },
  displayFrozen: false,

  effectiveMultiplier: { stomach: 1, love: 1 },
};

const { actions, reducer } = createSlice({
  name: 'inventory',

  initialState,

  reducers: {
    setEffectiveMultiplier(
      inventory,
      { payload }: PayloadAction<{ [key in 'stomach' | 'love']?: number }>,
    ) {
      Object.assign(inventory.effectiveMultiplier, payload);
    },

    setCompensation(
      inventory,
      { payload }: PayloadAction<Partial<Compensation>>,
    ) {
      Object.assign(inventory.compensation, payload);
    },

    setDisplayFrozen(inventory, { payload }: PayloadAction<boolean>) {
      inventory.displayFrozen = payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase('RESET_APP', () => initialState);
  },
});

export const { setCompensation, setDisplayFrozen, setEffectiveMultiplier } =
  actions;
export default reducer;
